<template>
	<div class="splitted-images" :class="{'splitted-images--center': data.layout === 'center'}">
		<div class="splitted-images__left" v-if="leftImage">
			<seo-image :data="leftImage.background" />
			<div class="splitted-images__overlay">
				<p v-html="data.textLeft"></p>
				<button-unit
					v-if="leftButton?.title"
					:options="{
						shape: ButtonUnitShape.ROUNDED,
						text: leftButton.title,
						bgColor: leftButton.background ?? '#fff',
						textColor: leftButton.color ?? '#000',
					}"
					@click-on-btn="goToPage(leftButton.url)"
				/>
			</div>
		</div>
		<div class="splitted-images__right" v-if="rightImage">
			<seo-image :data="rightImage.background" />
			<div class="splitted-images__overlay">
				<p v-html="data.textRight"></p>
				<button-unit
					v-if="rightButton?.title"
					:options="{
						shape: ButtonUnitShape.ROUNDED,
						text: rightButton.title,
						bgColor: rightButton.background ?? '#fff',
						textColor: rightButton.color ?? '#000',
					}"
					@click-on-btn="goToPage(rightButton.url)"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import { SplittedImagesComponentInterface } from "../Interfaces/Components/SplittedImagesComponentInterface";
import SeoImage from "../../../Components/SeoImage.vue";
import ButtonUnit from "../../../Components/Units/ButtonUnit.vue";
import { ButtonUnitShape } from "../../../Components/Units/Interfaces/ButtonUnitShape";

export default defineComponent({
	name: "SplittedImages",
	components: {
		SeoImage,
		ButtonUnit
	},
	props: {
		data: {
			type: Object as PropType<SplittedImagesComponentInterface>,
			required: true,
		}
	},
	computed: {
		leftImage() {
			return this.data.images?.[0] ?? null;
		},
		rightImage() {
			return this.data.images?.[1] ?? null;
		},
		leftButton() {
			return this.data.buttons?.[0] ?? null;
		},
		rightButton() {
			return this.data.buttons?.[1] ?? null;
		},
		ButtonUnitShape() {
			return ButtonUnitShape;
		}
	},
	methods: {
		goToPage(url): void {
			if(url) {
				window.location.href = url;
			}
		}
	}
});
</script>
